
// Slide-in animation for .shopify-section elements as they scroll into view.
// Uses IntersectionObserver API for the detection
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
//
// animations.css only hides a section once it has the 'section-anim-pending' class, which is set
// here and only for sections that start below the fold. Sections in view on load (or restored by a
// reload / back navigation / anchor) are never hidden, so content that renders there, such as the
// Athos recommendation skeletons, does not jump, whatever order the CSS and JS load in.
(function addInViewportClass(elements) {
  const threshold = Shopify || Shopify.designMode === true ? 0 : 0.15;
  const navigationType = performance.getEntriesByType('navigation')[0]?.type;
  const canAnimate = navigationType !== 'reload' && navigationType !== 'back_forward';

  // Intersections caused by scroll restoration or anchors must snap in place, only scrolling
  // by the user animates.
  let userInteracted = false;
  ['wheel', 'touchmove', 'keydown', 'pointerdown'].forEach((type) => {
    window.addEventListener(type, () => { userInteracted = true; }, { once: true, passive: true });
  });

  let isInitialCallback = true;
  const observer = new IntersectionObserver((entries) => {
    const initial = isInitialCallback;
    isInitialCallback = false;

    entries.forEach((entry) => {
      const section = entry.target;

      if (entry.isIntersecting) {
        if (!initial && canAnimate && !userInteracted) section.classList.add('ignore-section-animation');
        section.classList.add('section-anim-in');
        section.classList.add('section-in-view');
        section.dispatchEvent(new CustomEvent('section:in-viewport'));
      } else {
        if (initial && canAnimate) section.classList.add('section-anim-pending');
        section.classList.remove('section-in-view');
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: [threshold, 1],
  });

  elements.forEach((el) => {
    observer.observe(el);
  });
})(document.querySelectorAll('.shopify-section'))
